import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate, formatINR } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { useLang } from "@/contexts/LanguageContext";
import { StatusPill } from "@/components/StatusPill";

export default function BankApplications() {
  const [apps, setApps] = useState([]);
  const { t, tv } = useLang();
  useEffect(() => { api.get("/applications").then((r) => setApps(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="bank-applications">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 brand-heading">{t("a_title")}</h1>
        <p className="text-slate-600 mt-1 text-sm">{t("ba_sub")}</p>
      </div>
      <div className="overflow-x-auto table-scroll rounded-lg border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-widest text-slate-500 border-b border-slate-200 bg-slate-50">
            <tr>
              <th className="py-3 px-4">{t("col_business")}</th><th className="py-3 px-4">{t("col_requested")} (₹)</th><th className="py-3 px-4">{t("col_ref")}</th>
              <th className="py-3 px-4">{t("col_stage")}</th><th className="py-3 px-4">{t("col_updated")}</th><th className="py-3 px-4"></th>
            </tr>
          </thead>
          <tbody>
            {apps.map((a) => (
              <tr key={a.id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`bank-app-${a.id}`}>
                <td className="py-3 px-4">
                  <div className="font-medium text-slate-900">{a.business_name || a.business_id?.slice(0, 8)}</div>
                  {a.purpose && <div className="text-xs text-slate-500">{tv(a.purpose)}</div>}
                </td>
                <td className="py-3 px-4 font-semibold" data-testid={`bank-app-amount-${a.id}`}>{a.requested_amount ? formatINR(a.requested_amount) : "—"}</td>
                <td className={`py-3 px-4 text-xs ${a.lender_ref_no ? "font-mono" : "text-slate-500"}`} data-testid={`bank-app-ref-${a.id}`}>{a.lender_ref_no || t("ba_unassigned")}</td>
                <td className="py-3 px-4">
                  <StatusPill status={a.status} />
                  <div className="text-[11px] text-slate-500 mt-1">{tv(a.status)}</div>
                </td>
                <td className="py-3 px-4 text-slate-500">{formatDate(a.updated_at)}</td>
                <td className="py-3 px-4"><Link to={`/bank/applications/${a.id}`} data-testid={`bank-app-open-${a.id}`} className="text-xs font-semibold text-slate-900 hover:text-orange-600">{t("open")}</Link></td>
              </tr>
            ))}
            {apps.length === 0 && <tr><td colSpan={6} className="py-6 text-center text-slate-500">{t("ba_none")}</td></tr>}
          </tbody>
        </table>
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
